import React, { useEffect, useMemo, useState } from "react";
import { NumericFormat } from "react-number-format";
import { useHistory, useLocation } from "react-router-dom";
import { Formik } from "formik";
import axios from "axios";
import _ from "lodash";
import { v4 as uuidv4 } from "uuid";

import { errorSwal, successSwal } from "../../../helper/sweetalert";
import {
  COLOR_WHITE,
  LINEAR_GRADIENT_BG,
  S3_URL,
  USER_KEY,
} from "../../../const";

import {
  GET_PRODUCT_GENBARCODE,
  GET_PRODUCTS,
} from "../../../apollo/product/query";
import { GET_PRESIGN_URL } from "../../../apollo/presignUrl/query";
import { UPDATE_PRODUCT_VARIANT } from "../../../apollo/productVariant/mutation";
import { useLazyQuery, useMutation } from "@apollo/client";
import { GET_SUVIVALS, GET_UNITS } from "../../../apollo/unit/Query";
import { GET_ATTRIBUTES } from "../../../apollo/attribute/query";
import { GET_ATTRIBUTEVALUES } from "../../../apollo/attributeValue/query";

import CloudUploadOutlinedIcon from "@mui/icons-material/CloudUploadOutlined";
import ClearIcon from "@mui/icons-material/Clear";
import AddIcon from "@mui/icons-material/Add";

import { Col, Form, InputGroup, Row, Button, Spinner } from "react-bootstrap";
import BreadCrumbComponent from "../../../components/BreadCrumbComponent";
import useWindowDimensions from "../../../helper/windowDimensions";
import { ReactIcons } from "../../../icons";

function EditProductVariant() {
  const shopId = JSON.parse(localStorage.getItem(USER_KEY))?.data?.shop?.id;
  const historys = useHistory();
  const location = useLocation();
  const variantState = location.state?.state || location.state || null;

  const [unit, setUnit] = useState();
  const [history] = useState([]);
  const [isChecked, setIsChecked] = useState(false);
  const [sortNumber, setSortNumber] = useState(0);
  const [selecteUnit, setSelectedUnit] = useState("");
  const [priceOptions, setPriceOptions] = useState([
    { price: 0, contain: "1", unit: "" },
  ]);
  const [genBarCode, setGenBarCode] = useState("");
  const [barcode, setBarCode] = useState("");
  const [addQuantity, setAddQuantity] = useState();
  const [removeQuantity, setRemoveQuantity] = useState();
  const [amountAllBase, setAmountAllBase] = useState(0);
  const [copyData, setCopyData] = useState({
    name: "",
    priceOptions: [{}],
    amount: "",
    amountAll: "",
    originPrice: "",
    cfMessage: "",
    currency: "LAK",
    detail: "",
    barCode: "",
    image: "",
    shippingCost: 0,
  });
  const [files, setFiles] = useState([]);
  const [imageLoading, setImageLoading] = useState(false);
  const { width } = useWindowDimensions();
  const [survivalDatas, setSurvivalDatas] = useState([]);
  const [selectSurvivalNumber, setSelectSurvivalNumber] = useState("");
  const [products, setProducts] = useState([]);
  const [selectedProductId, setSelectedProductId] = useState("");
  const [existingImages, setExistingImages] = useState([]);
  const [
    selectedAttributeValueByAttributeId,
    setSelectedAttributeValueByAttributeId,
  ] = useState({});

  const [getUnit, { data: GetUnitData, loading: loadingUnit }] = useLazyQuery(
    GET_UNITS,
    { fetchPolicy: "network-only" },
  );

  const [getProducts, { data: productsData, loading: loadingProducts }] =
    useLazyQuery(GET_PRODUCTS, { fetchPolicy: "cache-and-network" });

  const [getAttributes, { data: attributesData, loading: loadingAttributes }] =
    useLazyQuery(GET_ATTRIBUTES, { fetchPolicy: "cache-and-network" });

  const [
    getAttributeValues,
    { data: attributeValuesData, loading: loadingAttributeValues },
  ] = useLazyQuery(GET_ATTRIBUTEVALUES, { fetchPolicy: "cache-and-network" });

  const [
    LoadGenBarCode,
    { data: GetGenBarCodeData, loading: loadingGenBarCode },
  ] = useLazyQuery(GET_PRODUCT_GENBARCODE, { fetchPolicy: "network-only" });

  const [
    getSurvivalData,
    { loading: loadingSurvival, data: survivalDatasLoad },
  ] = useLazyQuery(GET_SUVIVALS, {
    fetchPolicy: "cache-and-network",
  });

  const [getPresignUrl, { data: presignUrlData }] =
    useLazyQuery(GET_PRESIGN_URL);

  const [updateProductVariant, { loading: loadingUpdate }] = useMutation(
    UPDATE_PRODUCT_VARIANT,
  );

  useEffect(() => {
    _fecthUnit();
  }, []);

  useEffect(() => {
    if (!shopId) return;
    getProducts({
      variables: {
        where: {
          shop: shopId,
          isDeleted: false,
          hasVariant: true,
        },
        orderBy: "createdAt_DESC",
        limit: 1000,
      },
    });
    getAttributes({
      variables: {
        where: {
          shop: shopId,
          isDeleted: false,
        },
        orderBy: "createdAt_DESC",
        limit: 1000,
      },
    });
    getAttributeValues({
      variables: {
        where: {
          shop: shopId,
          isDeleted: false,
        },
        orderBy: "createdAt_DESC",
        limit: 5000,
      },
    });
  }, [getProducts, getAttributes, getAttributeValues, shopId]);

  useEffect(() => {
    if (GetUnitData) setUnit(GetUnitData?.units?.data);
  }, [GetUnitData]);

  useEffect(() => {
    if (productsData) setProducts(productsData?.products?.data || []);
  }, [productsData]);

  useEffect(() => {
    if (GetGenBarCodeData) {
      const number = GetGenBarCodeData?.products?.total + 1;
      let _genBarCode = number;
      if (number <= 9) _genBarCode = "00000" + _genBarCode;
      else if (number <= 99) _genBarCode = "0000" + _genBarCode;
      else if (number <= 999) _genBarCode = "000" + _genBarCode;
      else if (number <= 9999) _genBarCode = "00" + _genBarCode;
      setGenBarCode(_genBarCode);
    }
  }, [GetGenBarCodeData]);

  // Removed onFileUpload logic from useEffect - handled in handleUpload now

  useEffect(() => {
    const userData = localStorage.getItem("SHOP_DATA");
    if (userData) {
      const locals = JSON.parse(userData);
      if (locals) {
        fetchSurvivalDatas(locals.id);
      }
    }
  }, []);

  useEffect(() => {
    if (survivalDatasLoad) {
      setSurvivalDatas(survivalDatasLoad?.survivals?.data || []);
    }
  }, [survivalDatasLoad]);

  useEffect(() => {
    if (!variantState) return;

    setSelectedProductId(
      variantState?.product?.id || variantState?.product?._id || "",
    );
    setCopyData((prev) => ({
      ...prev,
      amount: variantState?.amount ?? "",
      amountAll: variantState?.amountAll ?? "",
      originPrice: variantState?.originPrice ?? "",
      currency: variantState?.currency || "LAK",
      detail: variantState?.note || "",
    }));
    setPriceOptions([
      { price: variantState?.price ?? 0, contain: "1", unit: "" },
    ]);
    setExistingImages(variantState?.image || []);
    setAmountAllBase(
      typeof variantState?.amountAll === "number"
        ? variantState.amountAll
        : variantState?.amount ?? 0,
    );
    setAddQuantity(null);
    setRemoveQuantity(null);

    const selectedMap = (variantState?.attributeValues || []).reduce(
      (acc, value) => {
        const attrId = value?.attribute?.id;
        if (!attrId || !value?.id) return acc;
        if (!acc[attrId]) acc[attrId] = [];
        acc[attrId].push(value.id);
        return acc;
      },
      {},
    );
    setSelectedAttributeValueByAttributeId(selectedMap);
  }, [variantState]);

  const attributes = useMemo(() => {
    const list = attributesData?.attributes?.data ?? [];
    return list
      .map((a) => ({ id: a?.id ?? "", name: (a?.name ?? "").trim() }))
      .filter((a) => a.id && a.name);
  }, [attributesData]);

  const attributeValues = useMemo(() => {
    const list = attributeValuesData?.attributeValues?.data ?? [];
    return list
      .map((v) => ({
        id: v?.id ?? "",
        value: (v?.value ?? "").trim(),
        attributeId: v?.attribute?.id ?? "",
        attributeName: (v?.attribute?.name ?? "").trim(),
      }))
      .filter((v) => v.id && v.value && v.attributeId);
  }, [attributeValuesData]);

  const attributeValuesByAttributeId = useMemo(() => {
    const map = new Map();
    for (const v of attributeValues) {
      if (!map.has(v.attributeId)) map.set(v.attributeId, []);
      map.get(v.attributeId).push(v);
    }
    for (const list of map.values())
      list.sort((a, b) => a.value.localeCompare(b.value));
    return map;
  }, [attributeValues]);

  const attributeValueById = useMemo(() => {
    const map = new Map();
    for (const v of attributeValues) map.set(v.id, v);
    return map;
  }, [attributeValues]);

  const selectedAttributeValueText = useMemo(() => {
    const parts = [];
    for (const a of attributes) {
      const selectedIds = selectedAttributeValueByAttributeId[a.id] || [];
      if (!selectedIds.length) continue;
      const values = selectedIds
        .map((id) => attributeValueById.get(id)?.value)
        .filter(Boolean);
      if (!values.length) continue;
      parts.push(`${a.name}: ${values.join(", ")}`);
    }
    return parts.join(" / ");
  }, [attributeValueById, attributes, selectedAttributeValueByAttributeId]);

  const fetchSurvivalDatas = async (shopId) => {
    if (loadingSurvival) return;

    try {
      await getSurvivalData({
        variables: {
          where: {
            shop: shopId,
            status: true,
            isDeleted: false,
          },
        },
      });
    } catch (err) {
      console.log("Load survival error: ", err);
    }
  };

  const _loadGenBarCode = async () => {
    const shopId = await JSON.parse(localStorage.getItem(USER_KEY))?.data?.shop
      ?.id;

    await LoadGenBarCode({
      variables: {
        where: {
          shop: shopId,
        },
      },
    });
  };

  const _fecthUnit = async () => {
    const shopId = await JSON.parse(localStorage.getItem(USER_KEY))?.data?.shop
      ?.id;
    await getUnit({
      variables: {
        where: {
          isDeleted: false,
          shop: shopId,
        },
      },
    });
  };

  const handleUpdateProductVariant = async (values) => {
    try {
      if (loadingUpdate) return;

      if (!variantState?.id) {
        return errorSwal("ບໍ່ພົບຂໍ້ມູນສິນຄ້າ");
      }

      if (!selectedProductId) {
        return errorSwal("ກະລຸນາເລືອກສິນຄ້າ!");
      }

      const amount = parseFloat(
        values.amount ? values?.amount.toString().replace(/,/g, "") : 0,
      );
      const amountAllInput =
        values.amountAll !== undefined && values.amountAll !== null && values.amountAll !== ""
          ? parseFloat(values.amountAll.toString().replace(/,/g, ""))
          : null;
      const addQty = parseInt(
        addQuantity ? addQuantity.toString().replace(/,/g, "") : 0,
        10,
      );
      const removeQty = parseInt(
        removeQuantity ? removeQuantity.toString().replace(/,/g, "") : 0,
        10,
      );
      let finalAmount = parseInt(amount, 10);
      let finalAmountAll = amountAllBase ?? finalAmount;
      const shouldSendAmountAll = amountAllInput !== null || addQty > 0;
      if (addQty > 0) {
        finalAmount = finalAmount + addQty;
        finalAmountAll = finalAmountAll + addQty;
      } else if (removeQty > 0) {
        finalAmount = Math.max(finalAmount - removeQty, 0);
      }
      if (amountAllInput !== null && !Number.isNaN(amountAllInput)) {
        finalAmountAll = amountAllInput;
      }
      const originPrice = parseFloat(
        values.originPrice
          ? values?.originPrice.toString().replace(/,/g, "")
          : 0,
      );
      const price = priceOptions.length > 0 ? priceOptions[0].price : 0;

      const attributeValues = Object.values(
        selectedAttributeValueByAttributeId,
      )
        .flat()
        .filter((id) => id && id.trim() !== "");

      let data = {
        product: selectedProductId,
        amount: finalAmount,
        attributeValues: attributeValues,
        price: price,
        originPrice: originPrice,
        shop: shopId,
        currency: values.currency || "LAK",
        note: values.detail || "",
      };
      if (shouldSendAmountAll && !Number.isNaN(finalAmountAll)) {
        data = { ...data, amountAll: finalAmountAll };
      }

      if (existingImages.length > 0) {
        data = { ...data, image: existingImages };
      }

      await updateProductVariant({
        variables: {
          where: { id: variantState?.id },
          data,
        },
      });

      successSwal("ແກ້ໄຂສິນຄ້າສຳເລັດແລ້ວ!");
      localStorage.setItem("REFRESH_PRODUCT_VARIANT", "1");
      setTimeout(() => {
        historys.goBack();
      }, 300);
    } catch (err) {
      errorSwal("ເກີດຂໍ້ຜິດພາດກະລຸນາລອງໃຫມ່ອີກຄັ້ງ");
    }
  };

  const ImageThumb = ({ image, style }) => {
    if (typeof image === "string") {
      return (
        <img
          src={S3_URL + image}
          alt="variant"
          style={{
            objectFit: "cover",
            borderRadius: 8,
            height: 150,
            width: 150,
            ...style,
          }}
        />
      );
    }
    return (
      <img
        src={URL.createObjectURL(image)}
        alt={image?.name}
        style={{
          borderRadius: 8,
          height: 150,
          width: 150,
          objectFit: "cover",
          ...style,
        }}
      />
    );
  };

  const handleRemoveFile = (index) => {
    setExistingImages((prev) => prev.filter((_, i) => i !== index));
    setFiles((prev) => prev.filter((_, i) => i !== index));
  };

  const handleSetCover = (index) => {
    if (index === 0) return;

    setExistingImages((prev) => {
      const newImages = [...prev];
      const selected = newImages.splice(index, 1)[0];
      newImages.unshift(selected);
      return newImages;
    });

    setFiles((prev) => {
      const newFiles = [...prev];
      if (newFiles[index]) {
        const selectedFile = newFiles.splice(index, 1)[0];
        newFiles.unshift(selectedFile);
      }
      return newFiles;
    });
  };

  const handleUpload = async (event) => {
    setImageLoading(true);
    const selectedFiles = Array.from(event.target.files);
    if (selectedFiles.length === 0) {
      setImageLoading(false);
      return;
    }

    try {
      for (const file of selectedFiles) {
        const ext = file.name.split(".").pop();
        const filename = uuidv4() + "." + ext;

        const res = await getPresignUrl({
          variables: {
            name: filename,
          },
        });

        const url = res?.data?.preSignedUrl?.url;
        if (url) {
          await axios.put(url, file, {
            headers: {
              "Content-Type": "file/*; image/*",
              Accept: "application/json",
              "Access-Control-Allow-Origin": "*",
              "Access-Control-Allow-Methods": "DELETE, POST, GET, OPTIONS",
              "Access-Control-Allow-Headers":
                "Content-Type, Access-Control-Allow-Headers, Authorization, X-Requested-With",
            },
          });
          setFiles((prev) => [...prev, file]);
          setExistingImages((prev) => [...prev, filename]);
        }
      }
    } catch (error) {
      console.log(error);
    } finally {
      setImageLoading(false);
    }
  };

  const handleAddMorePrice = () => {
    const _newPriceOptions = [...priceOptions, { price: 0, contain: "" }];
    setPriceOptions(_newPriceOptions);
  };

  const _handleChangePrie = (value, i) => {
    const newArray = [...priceOptions];
    newArray[i] = {
      ...newArray[i],
      price: parseFloat(value.toString().replace(/,/g, "")),
    };
    setPriceOptions(newArray);
  };

  const _handleChangeContain = (valueContain, iContain) => {
    const newArrayContain = [...priceOptions];
    newArrayContain[iContain] = {
      ...newArrayContain[iContain],
      contain: valueContain.toString(),
    };
    setPriceOptions(newArrayContain);
  };

  const _handleChangeUnit = (valueUnit, iUnit) => {
    const newArrayUnit = [...priceOptions];
    newArrayUnit[iUnit] = {
      ...newArrayUnit[iUnit],
      unit: valueUnit.toString(),
    };
    setPriceOptions(newArrayUnit);
  };

  const handleDelete = (i) => {
    const deletVal = [...priceOptions];
    deletVal.splice(i, 1);
    setPriceOptions(deletVal);
  };

  const handleCheckboxChange = (event) => {
    const checked = event.target.checked;
    setIsChecked(checked);
    if (checked) _loadGenBarCode();
  };

  const handleChangAddbarCode = (event) => {
    setBarCode(event.target.value);
  };

  return (
    <>
      <BreadCrumbComponent
        goback={() => historys.goBack()}
        txtFirst="ສາງສິນຄ້າ"
        txtSecond="ແກ້ໄຂສິນຄ້າ"
      />

      <Formik
        enableReinitialize={true}
        initialValues={copyData}
        validate={(values) => {
          const errors = {};
          if (!selectedProductId) {
            errors.product = "ກະລຸນາເລືອກສິນຄ້າ!";
          }
          if (!values.amount) {
            errors.amount = "ກະລຸນາປ້ອນຈຳນວນກ່ອນ!";
          }
          if (priceOptions[0]?.price <= 0) {
            errors.priceOptions = "ກະລຸນາປອ້ນລາຄາຂາຍ!";
          }

          return errors;
        }}
        onSubmit={(values) => {
          handleUpdateProductVariant(values);
        }}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
        }) => {
          const currentAmount = parseInt(
            values.amount ? values.amount.toString().replace(/,/g, "") : 0,
            10,
          );
          const addQtyValue = parseInt(
            addQuantity ? addQuantity.toString().replace(/,/g, "") : 0,
            10,
          );
          const removeQtyValue = parseInt(
            removeQuantity ? removeQuantity.toString().replace(/,/g, "") : 0,
            10,
          );
          const remainingAmount =
            addQtyValue > 0
              ? currentAmount + addQtyValue
              : removeQtyValue > 0
                ? Math.max(currentAmount - removeQtyValue, 0)
                : currentAmount;
          return (
          <div
            style={{
              display: "flex",
              justifyContent: "start",
              alignItems: "start",
              flexDirection: width > 700 ? "row" : "column",
              padding: 20,
            }}
          >
            <div
              style={{
                width: width > 700 ? "35%" : "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "start",
                padding: 10,
              }}
            >
              <div style={{ textAlign: "center" }}>
                <input
                  type="file"
                  id="file-upload"
                  onChange={handleUpload}
                  multiple
                  hidden
                />
                <div
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: 10,
                    justifyContent: "center",
                    maxWidth: 400,
                  }}
                >
                  {existingImages.map((img, index) => (
                    <div
                      key={index}
                      style={{
                        position: "relative",
                        width: 150,
                        height: 150,
                        border: index === 0 ? "2px solid #3C169B" : "1px solid #E5E7EB",
                        borderRadius: 8,
                        overflow: "hidden",
                        cursor: index === 0 ? "default" : "pointer",
                      }}
                      onClick={() => handleSetCover(index)}
                    >
                      <ImageThumb
                        image={files.find(f => {
                          // Rough logic to match the newly uploaded file preview with its filename
                          // In practice, it's better to keep a combined state, but we'll try to find it
                          // Actually, since we push to both at same time, index should match if we only added new ones.
                          // But existing ones don't have 'files' entry.
                          // Let's refine the logic: we use img if it's string, otherwise we check if it's a file
                          return false; // fallback to img
                        }) || img}
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                          opacity: index === 0 ? 1 : 0.8,
                        }}
                      />
                      {index === 0 ? (
                        <div
                          style={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            background: "#3C169B",
                            color: "#fff",
                            padding: "2px 6px",
                            fontSize: 10,
                            borderBottomRightRadius: 8,
                            zIndex: 1,
                          }}
                        >
                          ພາບໜ້າປົກ
                        </div>
                      ) : (
                        <div
                          style={{
                            position: "absolute",
                            bottom: 0,
                            left: 0,
                            right: 0,
                            background: "rgba(0,0,0,0.5)",
                            color: "#fff",
                            fontSize: 10,
                            textAlign: "center",
                            padding: "2px 0",
                          }}
                        >
                          ຕັ້ງເປັນພາບໜ້າປົກ
                        </div>
                      )}
                      <div
                        onClick={(e) => {
                          e.stopPropagation();
                          handleRemoveFile(index);
                        }}
                        style={{
                          position: "absolute",
                          top: 5,
                          right: 5,
                          background: "rgba(255, 255, 255, 0.8)",
                          borderRadius: "50%",
                          cursor: "pointer",
                          display: "flex",
                          padding: 2,
                          zIndex: 2,
                        }}
                      >
                        <ClearIcon style={{ fontSize: 16, color: "red" }} />
                      </div>
                    </div>
                  ))}

                  <label htmlFor="file-upload" style={{ margin: 0 }}>
                    <div
                      style={{
                        backgroundColor: "#F9FAFB",
                        height: 150,
                        width: 150,
                        border: "1px dashed #93989F",
                        borderRadius: 8,
                        cursor: "pointer",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      {imageLoading ? (
                        <Spinner animation="border" variant="primary" />
                      ) : (
                        <>
                          <CloudUploadOutlinedIcon
                            sx={{ fontSize: 40, color: "#93989F" }}
                          />
                          <p style={{ color: "#93989F", fontSize: 12 }}>ເພີ່ມຮູບ</p>
                        </>
                      )}
                    </div>
                  </label>
                </div>
                {existingImages.length > 1 && (
                  <p style={{ marginTop: 10, fontSize: 12, color: "#6B7280" }}>
                    ໝາຍເຫດ: ຄລິກທີ່ຮູບທີ່ຕ້ອງການເພື່ອເປັນຮູບປົກ
                  </p>
                )}
              </div>
            </div>

            <div
              style={{
                width: "100%",
                background: COLOR_WHITE,
                padding: "2em",
                borderRadius: 4,
              }}
            >
              <Row>
                <Col className="col-6">
                  <Form.Label>ເລືອກສິນຄ້າ</Form.Label>
                  <Form.Select
                    name="product"
                    value={selectedProductId}
                    onChange={(e) => setSelectedProductId(e.target.value)}
                    style={{
                      border:
                        errors.product && touched.product && errors.product
                          ? "solid 1px red"
                          : "",
                    }}
                    disabled={loadingProducts}
                  >
                    <option value="">--ເລືອກສິນຄ້າ--</option>
                    {products.map((product) => (
                      <option key={product.id} value={product.id}>
                        {product.name}
                      </option>
                    ))}
                  </Form.Select>
                  <small style={{ color: "red" }}>{errors.product}</small>
                </Col>
                <Col className="col-3">
                  <Form.Label>ລະຫັດບຣາໂຄດ</Form.Label>
                  {isChecked ? (
                    <Form.Control
                      name="barcodeadd"
                      aria-label="Default select example"
                      onChange={handleChangAddbarCode}
                      value={barcode}
                      placeholder="ID bar code..."
                      disabled
                    />
                  ) : (
                    <Form.Control
                      name="barcodeadd"
                      aria-label="Default select example"
                      onChange={handleChangAddbarCode}
                      value={barcode}
                      placeholder="ເລກ ID barCode..."
                    />
                  )}
                </Col>
                <Col className="col-3">
                  <Form.Label>
                    {" "}
                    <Form.Check
                      aria-label="option 1"
                      value={isChecked}
                      checked={isChecked}
                      onChange={handleCheckboxChange}
                      label="ໂອໂຕ ບຣາໂຄດ"
                    />{" "}
                  </Form.Label>
                  <Form.Control
                    name="barcode"
                    aria-label="Default select example"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={genBarCode}
                    placeholder="ເລກ ID ສິ້ນຄ້າ..."
                    disabled
                  />
                </Col>
              </Row>
              <br />

              <Row className="mt-2">
                <Col className="col-12">
                  <Form.Label>ລະຫັດ CF</Form.Label>
                  <Form.Control
                    name="cfMessage"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values?.cfMessage}
                    placeholder="ປ້ອນ...."
                  />
                </Col>
              </Row>
              <br />

              <>
                <Row className="mt-2">
                  <Col className="col-12">
                    <Form.Label>ຄຸນລັກສະນະ</Form.Label>
                    <div
                      style={{
                        border: "1px solid #E5E7EB",
                        borderRadius: 6,
                        padding: 12,
                        background: "#F9FAFB",
                      }}
                    >
                      <Row>
                        {attributes.length > 0 ? (
                          attributes.map((a) => {
                            const valuesForAttr =
                              attributeValuesByAttributeId.get(a.id) ?? [];
                            return (
                              <Col key={a.id} className="col-6 mt-2">
                                <Form.Label style={{ marginBottom: 6 }}>
                                  {a.name}
                                </Form.Label>
                                <Form.Select
                                  multiple
                                  value={
                                    selectedAttributeValueByAttributeId[a.id] ??
                                    []
                                  }
                                  onChange={(e) => {
                                    const nextIds = Array.from(
                                      e.target.selectedOptions,
                                    ).map((option) => option.value);
                                    setSelectedAttributeValueByAttributeId(
                                      (prev) => ({
                                        ...prev,
                                        [a.id]: nextIds,
                                      }),
                                    );
                                  }}
                                  disabled={
                                    !shopId ||
                                    loadingAttributes ||
                                    loadingAttributeValues ||
                                    valuesForAttr.length === 0
                                  }
                                >
                                  <option value="">-- ເລືອກ --</option>
                                  {valuesForAttr.map((v) => (
                                    <option key={v.id} value={v.id}>
                                      {v.value}
                                    </option>
                                  ))}
                                </Form.Select>
                              </Col>
                            );
                          })
                        ) : (
                          <Col className="col-12">
                            <div style={{ color: "#6B7280" }}>
                              {loadingAttributes || loadingAttributeValues
                                ? "ກຳລັງໂຫຼດ..."
                                : "ບໍ່ພົບ Attribute"}
                            </div>
                          </Col>
                        )}
                      </Row>

                      <div style={{ marginTop: 10 }}>
                        <Form.Label style={{ marginBottom: 6 }}>
                          ເລືອກແລ້ວ
                        </Form.Label>
                        <Form.Control
                          value={selectedAttributeValueText}
                          disabled
                          placeholder="-"
                        />
                      </div>
                    </div>
                  </Col>
                </Row>

                <Row className="mt-2">
                  <Col className="col-3">
                    <Form.Label>ຈຳນວນ</Form.Label>
                    <NumericFormat
                      name="amount"
                      min={0}
                      className="form-control"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      placeholder="....."
                      value={values.amount}
                      thousandSeparator={true}
                      prefix={""}
                    />
                    <small style={{ color: "red" }}>{errors.amount}</small>
                  </Col>
                  <Col className="col-3">
                    <Form.Label>amountAll</Form.Label>
                    <NumericFormat
                      name="amountAll"
                      min={0}
                      className="form-control"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      placeholder="....."
                      value={values.amountAll}
                      thousandSeparator={true}
                      prefix={""}
                    />
                  </Col>
                  <Col className="col-3">
                    <Form.Label>ຄ່າຈັດສົ່ງ</Form.Label>
                    <NumericFormat
                      name="shippingCost"
                      min={0}
                      className="form-control"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      placeholder="ຄ່າຈັດສົ່ງ....."
                      value={values.shippingCost}
                      thousandSeparator={true}
                      prefix={""}
                    />
                    <small style={{ color: "red" }}>{errors.shippingCost}</small>
                  </Col>
                  <Col>
                    <Form.Label>ຫົວໜ່ວຍ</Form.Label>
                    <Form.Select
                      name="unitId"
                      aria-label="Default select example"
                      onChange={(e) => setSelectedUnit(e.target.value)}
                      onBlur={handleBlur}
                      value={selecteUnit}
                    >
                      <option value="">--ເລືອກ--</option>
                      {unit?.map((units, keyunit) => (
                        <option key={keyunit} value={units?.id}>
                          {units?.name}
                        </option>
                      ))}
                    </Form.Select>
                  </Col>
                </Row>

                <Row className="mt-2">
                  <Col className="col-3">
                    <Form.Label>ເພີ່ມຈຳນວນ</Form.Label>
                    <NumericFormat
                      name="addQuantity"
                      min={0}
                      className="form-control"
                      onChange={(e) => setAddQuantity(e?.target?.value)}
                      value={addQuantity}
                      placeholder="0"
                      thousandSeparator={true}
                      prefix={""}
                    />
                  </Col>
                  <Col className="col-3">
                    <Form.Label>ຈຳນວນທີ່ເຫຼືອຢູ່</Form.Label>
                    <NumericFormat
                      name="remainingQuantity"
                      min={0}
                      className="form-control"
                      value={remainingAmount}
                      thousandSeparator={true}
                      prefix={""}
                      disabled
                    />
                  </Col>
                  <Col className="col-3">
                    <Form.Label>ລົບຈຳນວນ</Form.Label>
                    <NumericFormat
                      name="removeQuantity"
                      min={0}
                      className="form-control"
                      onChange={(e) => setRemoveQuantity(e?.target?.value)}
                      value={removeQuantity}
                      placeholder="0"
                      thousandSeparator={true}
                      prefix={""}
                    />
                  </Col>
                </Row>

                <Row className="mt-2">
                  <Col>
                    <Form.Label>ລາຄາຕົ້ນທືນ</Form.Label>
                    <NumericFormat
                      name="originPrice"
                      min={0}
                      className="form-control"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      placeholder="ລາຄາຊື້ສິນຄ້າ..."
                      value={values.originPrice}
                      thousandSeparator={true}
                      prefix={""}
                    />
                  </Col>
                  <Col>
                    <Form.Label>ສະກຸນເງີນ</Form.Label>
                    <Form.Select
                      name="currency"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.currency}
                      style={{
                        border:
                          errors.currency && touched.currency && errors.currency
                            ? "solid 1px red"
                            : "",
                      }}
                    >
                      <option value="">--ເລືອກ--</option>
                      <option value="LAK">ກີບ</option>
                      <option value="BAHT">ບາດ</option>
                      <option value="USD">ໂດລາ</option>
                    </Form.Select>
                    <span style={{ color: "red" }}>{errors.currency}</span>
                  </Col>
                </Row>

                <Row className="mt-2">
                  {priceOptions.map((price, i) => {
                    return (
                      <>
                        <Form.Group>
                          <Row>
                            <Col>
                              <Form.Label>
                                ລາຄາຂາຍ
                                {i === 0
                                  ? ""
                                  : i === 1
                                    ? "2"
                                    : i === 2
                                      ? "3"
                                      : ""}
                              </Form.Label>
                              <InputGroup className="">
                                <NumericFormat
                                  className="form-control"
                                  min={1}
                                  name="priceOptionsprice"
                                  value={price.price}
                                  thousandSeparator={true}
                                  onChange={(e) => {
                                    if (
                                      parseFloat(price.price) >= 999999999999999
                                    )
                                      return;
                                    _handleChangePrie(e.target.value, i);
                                  }}
                                  style={{
                                    border:
                                      errors.priceOptions &&
                                      touched.priceOptions &&
                                      errors.priceOptions
                                        ? "solid 1px red"
                                        : "",
                                  }}
                                  placeholder="ລາຄາຂາຍສິ້ນຄ້າ..."
                                />
                              </InputGroup>
                              <small style={{ color: "red" }}>
                                {errors.priceOptions}
                              </small>
                            </Col>
                            <Col>
                              {i >= 1 ? (
                                <>
                                  <Form.Label>
                                    ລະບຸຈຳນວນສິນຄ້າຂອງລາຄາ{" "}
                                    {i === 0
                                      ? ""
                                      : i === 1
                                        ? "2"
                                        : i === 2
                                          ? "3"
                                          : ""}
                                  </Form.Label>
                                  <InputGroup className="mb-3">
                                    <Form.Control
                                      name="priceOptionsContain"
                                      placeholder="ປ້ອນ..."
                                      onBlur={handleBlur}
                                      value={price.contain}
                                      onChange={(e) => {
                                        _handleChangeContain(e.target.value, i);
                                      }}
                                    />
                                    {i === 0 ? (
                                      ""
                                    ) : (
                                      <InputGroup.Text
                                        style={{ cursor: "pointer" }}
                                        onClick={() => handleDelete(i)}
                                      >
                                        <ClearIcon />
                                      </InputGroup.Text>
                                    )}
                                  </InputGroup>
                                </>
                              ) : (
                                ""
                              )}
                            </Col>
                            <Col>
                              {i >= 1 ? (
                                <>
                                  <Form.Label>
                                    ຫົວໜວ່ຍຂອງລາຄາ{" "}
                                    {i === 0
                                      ? ""
                                      : i === 1
                                        ? "2"
                                        : i === 2
                                          ? "3"
                                          : ""}
                                  </Form.Label>
                                  <InputGroup className="mb-3">
                                    <Form.Select
                                      name="priceOptionsUnit"
                                      aria-label="Default select example"
                                      placeholder="ຫົວໝວ່ຍ..."
                                      onBlur={handleBlur}
                                      value={price.unit}
                                      onChange={(e) => {
                                        _handleChangeUnit(e.target.value, i);
                                      }}
                                    >
                                      <option value="">--ເລືອກ--</option>
                                      {unit?.map((units, keyunit) => (
                                        <option
                                          key={keyunit}
                                          value={units?.name}
                                        >
                                          {units?.name}
                                        </option>
                                      ))}
                                    </Form.Select>
                                    {i === 0 ? (
                                      ""
                                    ) : (
                                      <InputGroup.Text
                                        style={{ cursor: "pointer" }}
                                        onClick={() => handleDelete(i)}
                                      >
                                        <ClearIcon />
                                      </InputGroup.Text>
                                    )}
                                  </InputGroup>
                                </>
                              ) : (
                                ""
                              )}
                            </Col>
                          </Row>
                        </Form.Group>
                      </>
                    );
                  })}
                  <Col sm={8}></Col>
                  {priceOptions?.length >= 3 ? (
                    ""
                  ) : (
                    <Col sm={4}>
                      <div className="mt-2 d-flex justify-content-end align-items-end w-100">
                        <Button
                          onClick={() => handleAddMorePrice()}
                          variant="outline-secondary"
                        >
                          <AddIcon />
                          ເພີ່ມລາຄາຂາຍ
                        </Button>
                      </div>
                    </Col>
                  )}
                </Row>

                <Row className="mt-3">
                  <Col>
                    <Form.Label>ເລກຈັດລຽງສະແດງລຳດັບ</Form.Label>
                    <NumericFormat
                      name="containOptionThird"
                      min={0}
                      className="form-control"
                      onChange={(e) => setSortNumber(e.target.value)}
                      placeholder="ເລກຈັດລຽງ..."
                      value={sortNumber}
                      thousandSeparator={true}
                      prefix={""}
                    />
                  </Col>
                  <Col>
                    <Form.Label>ໝາຍເລກລອດ</Form.Label>
                    <Form.Select
                      onChange={(e) =>
                        setSelectSurvivalNumber(e?.target?.value)
                      }
                      value={selectSurvivalNumber}
                      aria-label="Default select example"
                    >
                      <option value="">--ເລືອກ--</option>
                      {survivalDatas.map((option, indexOption) => (
                        <option key={indexOption} value={option?.id}>
                          {option?.survivalNumber}
                        </option>
                      ))}
                    </Form.Select>
                  </Col>
                </Row>
              </>

              <Row>
                <Col>
                  <Form.Group
                    className="mb-3 mt-3"
                    controlId="exampleForm.ControlTextarea1"
                  >
                    <Form.Label>ລາຍລະອຽດເພີ່ມເຕີ່ມ (ຖ້າມີ)</Form.Label>
                    <Form.Control
                      name="detail"
                      as="textarea"
                      placeholder="ປ້ອນ..."
                      rows={3}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.detail}
                    />
                  </Form.Group>
                </Col>
              </Row>
              <div style={{ display: "flex", justifyContent: "end", gap: 5 }}>
                <Button
                  variant="outline-secondary"
                  className="px-4"
                  onClick={() => historys.goBack()}
                >
                  <ReactIcons.MdCancel /> ຍົກເລີກ
                </Button>
                <Button
                  variant="light"
                  onClick={() => handleSubmit()}
                  className="px-4"
                  style={{
                    background: LINEAR_GRADIENT_BG,
                    color: COLOR_WHITE,
                    border: "none",
                  }}
                >
                  <ReactIcons.FaCheckCircle /> ບັນທືກ
                </Button>
              </div>
            </div>
          </div>
          );
        }}
      </Formik>
    </>
  );
}

export default EditProductVariant;
